import { eventEmitter } from "@/utils/event-emitter.js";
import { appState } from "@/utils/state.js";
import { config } from "@/utils/config.js";

export function templateChange() {
  eventEmitter.on("templateChange", (index) => {
    const tempElem = document.querySelector(".template");
    if (index) {
      appState.setState("templateInd", Number(index));
    }
    tempElem.value = appState.getState("templateInd");

    appState.setState(
      "template",
      config.levels[appState.getState("levelInd")].puzzles[
        appState.getState("templateInd")
      ].name
    );
    appState.setState(
      "matrix",
      config.levels[appState.getState("levelInd")].puzzles[
        appState.getState("templateInd")
      ].matrix
    );
    eventEmitter.emit("renderBoard");
  });
}
